import styled from 'styled-components'

export const TableContainer = styled.div`
  position: relative;
`

export const LoadingContainer = styled.div``
